// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"72bdd59c","374":"ff1118c1","518":"1f3df120","539":"ed33f80f","558":"f138623a","674":"5dc9b10f"}[chunkId] + ".chunk.css";
};